<template>
  <div class="custom-select" ref="customSelect">
    <div class="custom-select-header" @click="toggleDropdown">
      <span>{{ selectedOption || "Select an option" }}</span>
      <span class="triangle" :class="{ 'rotate': dropdownVisible }"></span>
    </div>

    <div v-if="dropdownVisible" class="custom-select-dropdown" ref="dropdown" @click.stop>
      <div
        v-for="(group, index) in getOptionGroups(question.options)"
        :key="group.label"
        class="custom-optgroup"
        :class="'optgroup-' + (index + 1)"
      >
        <div class="custom-optgroup-label">{{ group.label }}</div>
        <div
          v-for="opt in group.options"
          :key="opt.id"
          class="custom-option"
          :class="{ selected: opt.id === selectedOptionId }"
          @click="selectOption(opt)"
        >
          {{ opt.option.split(" - ")[1] || opt.option }}
        </div>
        <hr>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: Object
  },
  data() {
    return {
      selectedOption: null,
      selectedOptionId: null,
      dropdownVisible: false
    };
  },
  methods: {
    toggleDropdown() {
      if (!this.dropdownVisible) {
        this.dropdownVisible = true;
        this.$nextTick(() => {
          this.scrollToSelectedOption();
        });
      } else {
        this.dropdownVisible = false;
      }
    },
    selectOption(option) {
      this.selectedOption = this.getProcessedOption(option.option);
      this.selectedOptionId = option.id;
      // console.log(option.id +'  in select ');
      this.$emit("input", option.option);
      this.dropdownVisible = false;
    },
    loadSelectedOption(question) {
      let selectedOption = question.options.find((option) => option.option === question.answer );
      if (selectedOption) {
        this.selectOption(selectedOption);
      }
    },
    getProcessedOption(option) {
      return typeof option === "string" ? option.split(" - ")[1] || option : "";
    },
    getOptionGroups(options) {
      let groups = [];
      options.forEach((option) => {
        let optionGroup = option.option.split(" - ")[0] || option.option;
        if (!groups.find((group) => group.label === optionGroup)) {
          groups.push({ label: optionGroup, options: [] });
        }
        groups.find((group) => group.label === optionGroup).options.push(option);
      });
      return groups;
    },
    scrollToSelectedOption() {
      this.$nextTick(() => {
        const dropdown = this.$refs.dropdown;
        const selectedOptionElement = dropdown?.querySelector('.custom-option.selected');

        if (selectedOptionElement) {
          const dropdownHeight = dropdown.clientHeight;
          const optionTop = selectedOptionElement.offsetTop;
          const optionHeight = selectedOptionElement.clientHeight;

          dropdown.scrollTop =
            optionTop - dropdownHeight / 2 + optionHeight / 2;
        }
      });
    },
    handleClickOutside(event) {
      if (!this.$refs.customSelect.contains(event.target)) {
        this.dropdownVisible = false;
      }
    }
  },
  watch: {
    question: {
      handler(newQuestion) {
        this.loadSelectedOption(newQuestion);
      },
      deep: true
    }
  },
  mounted() {
    this.loadSelectedOption(this.question);
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  }
};
</script>

<style scoped>
.custom-select {
  position: relative;
  display: inline-block;
  width: 100%;
  cursor: pointer;
  -webkit-user-select: none;
  z-index: 2;
}

.custom-select-header:hover {
  border: 1px solid #0f2e50;
}

.custom-select-header:focus {
  border: 1px solid black;
}

.custom-select-header {
  padding: 10px;
  border: 1px solid white;
  color: #333;
  font-size: 1.2em;
  font-family: "Poppins", sans-serif;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.triangle {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid gray;
  transition: transform 0.3s ease;
}

.triangle.rotate {
  transform: rotate(180deg);
}

.custom-select-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 0;
  border-top: 1px solid #ccc;
  background-color: white;
  max-height: 250px;
  overflow-y: auto;
  bottom: auto;
}

::-webkit-scrollbar {
  width: 12px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
}

::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: linear-gradient(to bottom, #3c6399 0%, #0f2e50 100%);
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
}
::-webkit-scrollbar-thumb:window-inactive {
  background: linear-gradient(to bottom, #3c6399 0%, #0f2e50 100%);
}

.custom-optgroup-label {
  font-weight: 600;
  padding: 20px 10px 10px;
  font-size: 1.19em;
  font-family: "Poppins", sans-serif;
}

.custom-option {
  padding: 7px 0 7px 30px;
  cursor: pointer;
  font-size: 1.1em;
  color: #333;
  font-family: "Poppins", sans-serif;
}

.custom-option:hover {
  background-color: #0000000a;
}

.selected {
  background-color: rgb(200 200 200 / 53%);
}

.optgroup-1 .custom-optgroup-label {
  color: rgb(96, 144, 125);
}

.optgroup-2 .custom-optgroup-label {
  color: green;
}

.optgroup-3 .custom-optgroup-label {
  color: blue;
}

.optgroup-4 .custom-optgroup-label {
  color: purple;
}

.optgroup-5 .custom-optgroup-label {
  color: orange;
}

.optgroup-6 .custom-optgroup-label {
  color: brown;
}

.optgroup-7 .custom-optgroup-label {
  color: rgb(125, 183, 183);
}

.optgroup-8 .custom-optgroup-label {
  color: rgb(173, 125, 133);
}

.optgroup-9 .custom-optgroup-label {
  color: black;
}

hr {
  margin: 10px 10px 0;
  border-top: 0.1em solid #ccc;
}
</style>
